import {
  ApolloClient,
  ApolloLink,
  HttpLink,
  InMemoryCache,
} from '@apollo/client';
import {
  isForceTraceActive,
  viewerUsingAdminPrivileges,
  viewingAs,
} from './admin/adminState';
import {urlPrefixed} from './forgeApi';
import {
  ShellAccountDataDocument,
  type ShellAccountDataQuery,
} from './generated/graphql';

const adminIdentityLink = new ApolloLink((operation, forward) => {
  const headers: Record<string, string> = {};
  if (viewerUsingAdminPrivileges()) {
    headers['use-admin-privileges'] = 'true';
  }
  const impersonatedUsername = viewingAs();
  if (impersonatedUsername) {
    headers['impersonated-username'] = impersonatedUsername;
  }
  const viewerEmail = (): string | null => {
    try {
      return (
        operation.client.cache.readQuery<ShellAccountDataQuery>({
          query: ShellAccountDataDocument,
        })?.viewer?.email ?? null
      );
    } catch {
      return null;
    }
  };
  if (isForceTraceActive(viewerEmail())) {
    headers['x-wandb-force-trace'] = 'true';
  }
  if (Object.keys(headers).length > 0) {
    operation.setContext(({headers: existingHeaders = {}}) => ({
      headers: {...existingHeaders, ...headers},
    }));
  }
  return forward!(operation);
});

export const createShellApolloClient = (): ApolloClient =>
  new ApolloClient({
    link: ApolloLink.from([
      adminIdentityLink,
      new HttpLink({
        uri: urlPrefixed('/graphql'),
        credentials: 'include',
      }),
    ]),
    cache: new InMemoryCache(),
  });

let client: ApolloClient | undefined;

export const shellApolloClient = (): ApolloClient => {
  client ??= createShellApolloClient();
  return client;
};
